import { EmailType } from 'modules/events/basics/enums/events.enums';

export const typesKeys = Object.keys(EmailType);
const typesValues = Object.values(EmailType);
export const emailTypeOptions = typesValues.map((value, index) => { return { id: typesKeys[index], label: value }; });
